import React, { Component } from 'react'
import Gallery from './containers/Gallery'
import feathers from '@feathersjs/feathers'
import socketio from '@feathersjs/socketio-client'
import io from 'socket.io-client'

class App extends Component {
  constructor(props) {
    super(props)
    let app
    if ((navigator && navigator.onLine) || !navigator || navigator.onLine === undefined) {
      const socket = io('https://api.miysis.be', {transports: ['websocket']})
      app = feathers()

      // Set up Socket.io client with the socket
      app.configure(socketio(socket))
    }

    this.app = app;
  }

  render() {
    const { app } = this;
    return (
        <Gallery app={app}/>
    )
  }
}

export default App
